/* eslint-disable import/no-named-as-default, global-require */

import 'experiments';
import 'polyfills';
import 'error-handler';

import Vue from 'vue';
import store from 'stores';
import { defer } from 'utils';

import BaseManager from 'managers/base.manager';
import StandardBaseLoader from 'managers/base.manager/loaders/standard';
import BaseElementsManager from 'managers/base-elements.manager';
import EventsManager from 'managers/events.manager';
import NewsManager from 'managers/news.manager';
import EncyclopediaManager from 'managers/encyclopedia.manager';
import PlatformManager from 'managers/platform.manager';
import StorageManager from 'managers/storage.manager';
import TutorialsManager from 'managers/tutorials.manager';
import TextTutorialsManager from 'managers/text-tutorials.manager';

import PopupsManager from 'managers/popups.manager';
import GesturesManager from 'managers/gestures.manager';
import DragManager from 'managers/drag.manager';
import DropManager from 'managers/drop.manager';
import StatsManager from 'managers/stats.manager';

import ConnectivityManager from 'managers/connectivity.manager';
import MixManager from 'managers/mix.manager';
import AnimationManager from 'managers/animation.manager';
import WorkspaceManager from 'managers/workspace.manager';
import VisibilityManager from 'managers/visibility.manager';
import AudioManager from 'managers/audio.manager';
import FirebaseManager from 'managers/firebase.manager';
// eslint-disable-next-line import/no-named-as-default
import AnalyticsManager from 'managers/analytics.manager';

import 'directives';

import './service-worker';
import App from './app.vue';

if (__DEV__ || __STAGING__) {
  // tslint:disable-next-line
  require('managers/hacks.manager');
}

Vue.config.productionTip = false;
Vue.config.devtools = __DEV__ || __STAGING__;
(Vue.config as any).debug = __DEV__ || __STAGING__;
Vue.config.silent = !__DEV__;
Vue.config.performance = __DEV__;

// tslint:disable no-unused-expression
// eslint-disable-next-line no-new
new Vue({
  store: store as any,
  el: '#app',
  render: (h) => h(App),
});



BaseManager.init(new StandardBaseLoader());
BaseElementsManager.init(store);
EventsManager.init(store);
NewsManager.init(store);
EncyclopediaManager.init(store);
PlatformManager.init();
StorageManager.init(store);
TutorialsManager.init();

store.dispatch('init');

defer(() => {
  PopupsManager.init(store);
  GesturesManager.init();
  DragManager.init(store);
  DropManager.init(store);
  StatsManager.init(store);
  FirebaseManager.init(store);

  defer(() => {
    TextTutorialsManager.init(store);
    ConnectivityManager.init(store);
    MixManager.init(store);
    AnimationManager.init(store);
    WorkspaceManager.init(store);
    VisibilityManager.init(store);

    AudioManager.init(store);
    AnalyticsManager.init(store);
  });
});

